import React from 'react';
import PropTypes from 'prop-types';

import { Field, reduxForm } from 'redux-form';
import Select from './../Select/Select';
const classNames = require('classnames');

require('./PressureSensorsSettings.scss');

class PressureSensorsSettings extends React.Component {
  render() {
    const { handleSubmit, pristine, reset, submitting, uiInfo, toggleSettingsDisplay } = this.props;
    const panelClasses = classNames(
      'pressure-sensors-settings',
      'alerts-settings',
      { 'show': this.props.showSettings }
    );

    const panelStyle = { height: uiInfo.pageHeight, width: 0.395 * (uiInfo.pageWidth - 10) };

    return (
      <div className={panelClasses} style={panelStyle}>
        <div className="sensors-header alerts-header">
          <div className="actions">
            <i className="icon-close" onClick={toggleSettingsDisplay} />
          </div>
          <h2>{this.context.t('pressure_sensors_options')}</h2>
        </div>
        <form className="form-horizontal" onSubmit={handleSubmit}>
          <fieldset>
            <legend>{this.context.t('sort_by')}</legend>
            <div className="form-group">
              <div className="col-xs-8">
                <Field name="PressureSensors.sortBy"
                  component={(props) =>
                  (<Select {...props}
                    isSearchable={false}
                    placeholderTitle={this.context.t('select')}
                    clearable={false}
                    options={[
                      { value: 'ID', label: this.context.t('sensor_id_default') },
                      { value: 'logger_id', label: this.context.t('logger_id') },
                      { value: 'aqs_logger_id', label: this.context.t('aqs_logger_id') },
                      { value: 'sensor_installation_date', label: this.context.t('sensor_install_date') },
                      { value: 'logger_last_active_time', label: this.context.t('last_active') },
                    ]}
                  />)
                  }
                />
              </div>
              <div className="col-xs-4">
                <Field name="PressureSensors.sortByDir"
                  component={(props) =>
                  (<Select {...props}
                    isSearchable={false}
                    placeholderTitle={this.context.t('select')}
                    clearable={false}
                    backspaceRemoves={false}
                    options={[
                      { value: 'asc', label: this.context.t('asc') },
                      { value: 'desc', label: this.context.t('desc') },
                    ]}
                  />)
                  }
                />
              </div>
            </div>
            <div className="text-right">
              <button className="btn btn-success" type="submit" disabled={pristine || submitting} onClick={toggleSettingsDisplay} >{this.context.t('save_and_apply')}</button>
            </div>
          </fieldset>
        </form>
      </div>
    );
  }
}

PressureSensorsSettings.contextTypes = {
  t: PropTypes.func.isRequired
};

// Decorate the form component
const pressureSensorsSettings = reduxForm({
  form: 'pressure-sensors-settings', // a unique name for this form
  enableReinitialize: true
})(PressureSensorsSettings);

export default pressureSensorsSettings;
